import { Table,
    Thead,Divider,Checkbox,
    Tbody,Avatar,
    Tr,
    Th,
    Td,
    TableContainer, Tooltip, Menu, MenuButton,MenuList,MenuItem,IconButton } from "@chakra-ui/react";
    import {CheckCircleIcon,CheckIcon,WarningIcon,RepeatIcon, CopyIcon,EditIcon, DeleteIcon, HamburgerIcon,ViewIcon, WarningTwoIcon} from '@chakra-ui/icons';
import { useState } from "react";
import '../../css/rgg.css';
    
/*vrijednosti iz tabele grunt.govscan*/
/*mode=all (Svi), mode="select" - način prikaza za odabir kod unosa migracija (prikazuje samo model, naziv datoteke, datum, vrijeme, broj dokumenata samo za one koji
    su spremni ua migraciju) */
const GovScanTable=({readonly=false,data=[],onEditItem,onDeleteItem,size='xs',pocetnirbr=0,mode="all",onSelectGovScanId,onDeselectGovScanId,modelFIlter="",selectedGovScansId=[],onStartUpdatePutniceSerBr})=>{
    const [selected,setSelected]=useState({model:"",govscanid:selectedGovScansId});
    const getStatusSkeniranje=(item)=>{
        //GOTOVO, U NAPREDOVANJU, GREŠKA
        //GOTOVO=haserror===false and datetimescanned !==null
        //U NAPREDOVANJU haserror===false and datetimescanned ===null
        //GREŠKA haserror===true and datetimescanned !==null
        let _r;
        if (item.has_error && item.migracija_id===-1) {  //crveno
            _r=(<Tooltip placement='left' label={"GREŠKA KOD SKENIRANJA: " + item.error_message}><WarningIcon color="red.500"/></Tooltip>);
        } else {
            if (item.scan_end===null) {//još se skenira
                _r=(<Tooltip placement='left' label={"SKENIRANJE U TIJEKU" + item.error_message}><RepeatIcon color="grunt2"/></Tooltip>);
        } else if (item.grlo_evidentirano){
            _r=(<Tooltip placement="left" label={"Neka od grla već su evidentirana u knjigama!" }><WarningTwoIcon  color="red.500"/></Tooltip>);
        } else {//ako je odskenirano
                //ako imamo samo jedan model u reultu
                if (item.numofmodels===1 || item.numofmodels===0) {
                    if (item.podaci_validirani) {
                        //ako je mifracija_id!==-1 onda je provedeno inače nije
                        if (item.migracija_id!==-1) {
                            _r=(<Tooltip placement="left" label={"Skenirana grla uspješno zabilježena u migracijama."}><CheckCircleIcon color="green.700"/></Tooltip>);        
                        } else {
                            _r=(<Tooltip placement="left" label={"Dokumenti uspješno očitani"}><CheckIcon color="green.500"/></Tooltip>);        
                        }
                        
                    } else {
                        _r=(<Tooltip placement="left" label={"Greška kod skeniranja pojedinih dokumenata"}><WarningIcon  color="red.500"/></Tooltip>);
                    }    
                } else {
                    _r=(<Tooltip placement="left" label={"Modeli više država u skeniranom setu dokumenata!" }><WarningTwoIcon  color="red.500"/></Tooltip>);
                }
                
                
            }
        }
        return _r;
    }
    
    const itemIsInFinalStatus=(item)=>{
        let _r=false;
        if (!item.has_error && item.scan_end!==null && item.numofmodels===1 && item.podaci_validirani) {
            _r=true;
        }
        return _r;
    }

    const showDeleteButton=(item)=>{
        //<MenuItem color={'red.600'} size={size} icon={<DeleteIcon/>} onClick={()=>{onDeleteItem(item.id)}}>Briši</MenuItem>
        if (mode==="all") {
            
            if (item.migracija_id!==-1) {
                return (<MenuItem size={size} icon={<DeleteIcon boxSize={'14px'} color={'red.600'}/>} isDisabled>Briši</MenuItem>)
            } else {
                return (<MenuItem size={size} icon={<DeleteIcon boxSize={'14px'} color={'red.600'}/>} onClick={()=>{onDeleteItem(item.id)}}>Briši</MenuItem>)
            }
            
        }
        
    }

    const showEditViewButton=(item)=>{
        if (mode==="all") {
            if (item.migracija_id!==-1) {
                return ((<MenuItem size={size} icon={<ViewIcon boxSize={'14px'} />} onClick={()=>onEditItem(item.id,item.pretpostavljeni_model,true)}>Pregled</MenuItem>))
            } else {
                return (<MenuItem size={size} icon={<EditIcon boxSize={'14px'} />} onClick={()=>onEditItem(item.id,item.pretpostavljeni_model,false)}>Uredi</MenuItem>)
            }
        }
    }

    const showUpdatePutniceSerBrButton=(item)=>{
        return ((<MenuItem isDisabled={!item.grlo_evidentirano} size={size} icon={<CopyIcon boxSize={'14px'} />} onClick={()=>onStartUpdatePutniceSerBr(item.id)}>Ažuriraj brojeve putnih listova</MenuItem>))
    }
    
    
    const modeAllShowData=()=>{
        if (mode==="all") {
            return (<>
            <TableContainer overflowY={'auto'} h={'75vh'} mb={'0.5rem'} className="noscroll">
                <Table size={size} fontSize={size} variant={'simple'} color={'grunt2'}>
                    <Thead>
                        <Tr>
                            <Th color={'grunt2.800'} textAlign={'center'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rbr</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Operater</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datoteka</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Model</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Broj dokumenata (odskenirano)</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum skeniranja</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Vrijeme skeniranja</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Trajanje (sec)</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Status</Th>
                        </Tr>
                    </Thead>
                    <Tbody borderBottomWidth={'1px'} borderBottomColor={'black'} borderBottomStyle={'solid'} zIndex={99}>
                        {data.map((item,index)=>{
                            
                                return (
                                    <Tr color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                                    _hover={{bg:'gray.100'}} h='2rem'>
                                        <Td textAlign={'center'}>
                                        <Menu size={size} zIndex={1}>
                                                        <MenuButton
                                                            as={IconButton}
                                                            aria-label='Options'
                                                            icon={<HamburgerIcon />}
                                                            variant={'outline'} size={size}
                                                            isDisabled={readonly}
                                                        />
                                                        <MenuList>
                                                            
                                                            {showEditViewButton(item)}
                                                            {showUpdatePutniceSerBrButton(item)}
                                                             <Divider/> 
                                                            {showDeleteButton(item)}
                                                        </MenuList>
                                                    </Menu>
                                        </Td>
                                        <Td textAlign={'center'}>{pocetnirbr+index}</Td>
                                        <Td textAlign={'center'}>{item.operater}</Td>
                                        <Td textAlign={'center'}>{item.filename}</Td>
                                        <Td textAlign={'center'}>{item.pretpostavljeni_model}</Td>
                                        <Td textAlign={'center'} >
                                        {readonly?"--":item.odskenirano===item.brdokumenata?item.brdokumenata:item.brdokumenata+' ('+ item.odskenirano+')'}
                                        </Td>
                                        <Td textAlign={'center'}>{new Date(item.scan_start).toLocaleDateString('uk-UK')}</Td>
                                        <Td textAlign={'center'}>{new Date(item.scan_start).toLocaleTimeString('hr-HR')}</Td>
                                        <Td textAlign={'center'}>{item.scan_end===null?"--":Math.floor(((new Date(item.scan_end)-new Date(item.scan_start))/1000))}</Td>
                                        <Td textAlign={'center'}>{getStatusSkeniranje(item)}</Td>
                                    </Tr>
                                )                                
                            
                        })}
                        
                    </Tbody>
                    
                </Table>
            </TableContainer>
            
            </>)
        }
    }

    const modeSelectShowData=()=>{
        if (mode==="select") {
            //ako je postavljen atribut modelFiletr
            let _d=[];
            if (modelFIlter!=="") {
                _d=data.filter((item)=>{return item.pretpostavljeni_model===modelFIlter});
            } else {
                _d=[...data];
            }
            return (
                <>
                    <TableContainer overflowY={'auto'} mb={'0.5rem'} h={'100%'} className="noscroll">
                <Table size={size} fontSize={size} variant={'simple'} color={'grunt2'}>
                    <Thead>
                        <Tr>
                            <Th color={'grunt2.800'} textAlign={'center'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Unio</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datoteka</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Model</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Goveda</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                            <Th color={'grunt2.800'} textAlign={'center'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Vrijeme</Th>
                         
                        </Tr>
                    </Thead>
                    <Tbody>
                        {_d.map((item,index)=>{
                            
                                return (
                                    <Tr color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                                    _hover={{bg:'gray.100'}} h='2rem' >
                                        <Td textAlign={'center'}>
                                            <Checkbox value={item.id}  defaultChecked={selected.govscanid.includes(item.id)}  isDisabled={selected.model===""?false:item.pretpostavljeni_model!==selected.model?true:false} id={index} key={item.id} colorScheme={'grunt2'} onChange={(event)=>{selectedItemChange(event,item.pretpostavljeni_model)}}></Checkbox>
                                            
                                        </Td>
                                        <Td textAlign={'center'}>
                                        <Tooltip label={item.operater} fontSize={'xs'} placement={'auto'}>
                                            <Avatar size={'xs'} color={'black'} bg={'grunt2.100'} name={item.operater}/>
                                        </Tooltip>
                                        </Td>
                                        <Td textAlign={'center'}>{item.filename}</Td>
                                        <Td textAlign={'center'}>{item.pretpostavljeni_model}</Td>
                                        <Td textAlign={'center'}>
                                        {item.odskenirano}
                                        </Td>
                                        <Td textAlign={'center'}>{new Date(item.scan_start).toLocaleDateString('uk-UK')}</Td>
                                        <Td textAlign={'center'}>{new Date(item.scan_start).toLocaleTimeString('hr-HR')}</Td>
                                    </Tr>
                                )    
                            
                            
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
                </>
            )
        }
    }
    const chkGetValue=(govscanid)=>{
        if (selected.govscanid.indexOf(govscanid)===-1) {
            return false;
        } else {
            return true;
        }

    }
    const selectedItemChange=(event,_newmodel)=>{
        const _ar=[...selected.govscanid];
        let _model=selected.model;
        if (!chkGetValue(Number(event.target.value))) {
            
            _ar.push(Number(event.target.value));
            if (_model==="") {
                _model=_newmodel;
            }
            onSelectGovScanId(Number(event.target.value),_model);
                
        } else {
            //remove
            const i=_ar.indexOf(Number(event.target.value));
            const removed=_ar.splice(i,1);
            onDeselectGovScanId(Number(event.target.value));
            if (_ar.length===0) {
                _model="";
            }
        }

        setSelected({...selected,model:_model,govscanid:_ar});
    }


    return (
        <>
            {modeAllShowData()}
             {modeSelectShowData()}
        </>
    )
}

export default GovScanTable;